import { useDealConnectV2Store } from '@/piniaStores/dealConnectV2Store'
import { useCompaniesStore } from '@/piniaStores/companiesStore'

// Fetches the client's deals and records which companies have them against the companies store.
// Returns whether that index is safe to read. A failed fetch leaves any previous index in place
// and returns false when nothing has loaded yet, so callers do not treat a failure as "no deals".
export function loadDealConnectV2Deals(): Promise<boolean> {
  const companiesStore = useCompaniesStore()
  let pending = companiesStore.loadingDealConnectV2Deals
  if (!pending) {
    pending = recordDealConnectV2Deals().finally(() => {
      if (companiesStore.loadingDealConnectV2Deals === pending) {
        companiesStore.loadingDealConnectV2Deals = null
      }
    })
    companiesStore.loadingDealConnectV2Deals = pending
  }
  return pending
}

async function recordDealConnectV2Deals(): Promise<boolean> {
  const dealConnectV2Store = useDealConnectV2Store()
  const companiesStore = useCompaniesStore()
  await dealConnectV2Store.fetchDeals()
  if (!dealConnectV2Store.error) {
    const companyIdsWithDeals = [...new Set(dealConnectV2Store.deals.flatMap((deal) => deal.companyId ?? []))]
    companiesStore.setDealConnectV2Deals(companyIdsWithDeals, dealConnectV2Store.deals.length > 0)
  }
  return companiesStore.dealConnectV2DealsLoaded
}
